export default "__VITE_ASSET__FpLpQDkI__"